import Vue from 'vue';
import VueRouter from 'vue-router';

import About from '@/vue-caas/views/About.vue';
import Login from '@/vue-caas/views/membership/Login.vue';
import CreateAccount from '@/vue-caas/views/membership/CreateAccount.vue';
import ForgotPassword from '@/vue-caas/views/membership/ForgotPassword.vue';
import ResetPassword from '@/vue-caas/views/membership/ResetPassword.vue';
import ChangedPassword from '@/vue-caas/views/membership/ChangedPassword.vue';
import ChangeExpiredPassword from '@/vue-caas/views/membership/ChangeExpiredPassword.vue';
import OtpVerify from '@/vue-caas/views/membership/OtpVerify.vue';
import MonitoringList from '@/vue-caas/views/monitoring/MonitoringList.vue';
import ProcessSearch from '@/vue-caas/views/admin/ProcessSearchMain.vue';
import ProcessMonitoring from '@/vue-caas/views/admin/MonitoringMain.vue';
import PartnerList from '@/vue-caas/views/partner/PartnerList.vue';
import FolderManager from '@/vue-caas/views/folder/FolderManager.vue';
import CommunicationList from '@/vue-caas/views/communication/CommunicationList.vue';
import ConverterList from '@/vue-caas/views/converter/ConverterList.vue';
import AIClientList from '@/vue-caas/views/aiclient/AIClientList.vue';
import CodeTableList from '@/vue-caas/views/codetable/CodeTableList.vue';
import IntegrationSets from '@/vue-caas/views/integrationset/IntegrationSets.vue';
import DbBroker from '@/vue-caas/views/dbbroker/DBBrokerList.vue';
import EdiIdList from '@/vue-caas/views/ediid/EdiIdList.vue';
import ProcessSample from '@/vue-caas/views/process/Sample.vue';
import Users from '@/vue-caas/views/user/UserList.vue';
import LoginUserMonitoring from '@/vue-caas/views/loginuser/LoginUserMonitoring.vue';
import ExternalPage from '@/vue-caas/views/external/ExternalPage.vue';
import CaasDashboard from '@/vue-caas/views/dashboard/Dashboard.vue';
import Report from '@/vue-caas/views/report/Report.vue';
import AddUser from '@/vue-caas/views/user/AddUser.vue';
import AddCommunication from '@/vue-caas/views/communication/CommunicationDetailWindow.vue';
import CodesList from '@/vue-caas/views/codes/CodesList.vue';
import VerifyEmail from '@/vue-caas/views/membership/VerifyEmail.vue';
import ResendEmail from '@/vue-caas/views/membership/ResendEmail.vue';
import FilterList from '@/vue-caas/views/filter/FilterList.vue';
import LogList from '@/vue-caas/views/admin/SystemLogList.vue';

// 2021.05.13 213979 SPKA-460 view process detail
import ProcessDetailWindow from '@/vue-caas/views/admin/ProcessSearchDetailWindow.vue';
import MonitoringStateView from '@/vue-caas/views/monitoring/MonitoringStateViewWindow.vue';
import MonitoringFileView from '@/vue-caas/views/monitoring/MonitoringFileViewWindow.vue';
import MonitoringDataInfoFileView from '@/vue-caas/views/monitoring/MonitoringDataInfoFileViewWindow.vue';
import EmbeddedMonitoringList from '@/vue-caas/views/monitoring/EmbeddedMonitoringList.vue';

// 2022.05.03 213960 new workflow
import AddProcessNew from '@/vue-caas/views/processnew/ProcessDetailDiagramWindowNew.vue';
import ProcessListNew from '@/vue-caas/views/processnew/ProcessListNew.vue';
import ProcessHistoryNew from '@/vue-caas/views/processnew/ProcessDetailDiagramWindowHistoryNew.vue';
import ProcessViewNew from '@/vue-caas/views/processnew/ProcessDetailDiagramWindowViewNew.vue';

// 2022.10.15 213960 Workflow Group
import WorkflowGroup from '@/vue-caas/views/workflowgroup/WorkflowGroupList.vue';
import AddWorkflowGroup from '@/vue-caas/views/workflowgroup/WorkflowGroupDetailDiagramWindow.vue';
import WorkflowGroupView from '@/vue-caas/views/workflowgroup/WorkflowGroupDetailDiagramWindowView.vue';

// Smart Agent
import DBAdapter from '@/vue-caas/views/dbadapter/DBAdapter.vue';
import DBAdapterBuilder from '@/vue-caas/views/dbadapter/DBAdapterBuilder.vue';
import UserComponent from '@/vue-caas/views/usercomp/UserComponent.vue';
import UserSimulator from '@/vue-caas/views/usercomp/UserSimulator.vue';
import ErrorPage from '@/vue-dlb/components/404';
import DataAnalysis from '@/vue-dlb/views/analysis/DataAnalysisList.vue';
import UploadFileView from '@/vue-dlb/views/commons/UploadFileView.vue';
import SRMList from '@/vue-dlb/views/srm/SRMList.vue';
import FlatFileLayout from '@/vue-dlb/views/flatfile/FlatFileLayout.vue';
import MapManagerList from '@/vue-dlb/views/map/MapManagerList.vue';
import RepositoryManagerList from '@/vue-dlb/views/repositorymanager/RepositoryManagerList.vue';
import MapBuilder from '@/vue-dlb/views/mapbuilder/MapBuilder.vue';
import CustomerEDIList from '@/vue-dlb/views/matching/CustomerEDIList.vue';
import EdiAnalyzedView from '@/vue-dlb/views/analysis/EdiAnalyzedView.vue';
import EdiAnalyzedView_SRM from '@/vue-dlb/views/srm/EdiAnalyzedView.vue';
import CompareMergeView from '@/vue-dlb/views/matching/MergeCompareDialog.vue';
import LayoutMatchingView from '@/vue-dlb/views/matching/LayoutMatchingView.vue';
import MappingDefinitionList from '@/vue-dlb/views/mappingdefinition/MappingDefinitionList.vue';
import ReferenceFileList from '@/vue-dlb/views/referencefile/ReferenceFileList.vue';
import TryTest from '@/vue-dlb/views/trytest/trytest.vue'; // for test
import FileView from '@/vue-dlb/views/trytest/JsonEditor.vue'; // for test
import MapEditor from '@/vue-dlb/views/trytest/MapEditor.vue'; // for test
import ExcelUpload from '@/vue-dlb/views/trytest/ExcelUpload.vue'; // for test
import EdiAnalyzedView_TEST from '@/vue-dlb/views/trytest/EdiAnalyzedView.vue'; // for test

// Parallel Process
import PaProcessList from '@/vue-dlb/views/paproc/PaProcessList.vue';
import CompFileView from '@/vue-dlb/views/paproc/CompFileView.vue';
import TargetFileView from '@/vue-dlb/views/paproc/TargetFileView.vue';

Vue.use(VueRouter);

const routes = [
  { path: '/about', component: About, name: 'About' },
  { path: '/login', component: Login, name: 'Login' },
  { path: '/otp', component: OtpVerify, name: 'OTP Verification' },
  { path: '/createaccount', component: CreateAccount, name: 'Create Account' },
  { path: '/forgotpassword', component: ForgotPassword, name: 'Forgot Password' },
  { path: '/resetpassword/:usrId/:hashKey', component: ResetPassword, name: 'Reset Password' },
  { path: '/verifyemail/:usrId/:hashKey', component: VerifyEmail, name: 'Verify Email' },
  { path: '/resendemail/:usrId', component: ResendEmail, name: 'Resend Email' },
  { path: '/changedpassword', component: ChangedPassword, name: 'Changed Password' },
  {
    path: '/changepassword/:usrId',
    component: ChangeExpiredPassword,
    name: 'Change Expired Password',
  },
  {
    path: '/monitoring',
    component: MonitoringList,
    name: 'Monitoring',
    meta: { title: 'Transaction Log' },
  },
  {
    path: '/admin/search',
    component: ProcessSearch,
    name: 'Process Search',
    meta: { title: 'Process Search' },
  },
  {
    path: '/admin/monitoring',
    component: ProcessMonitoring,
    name: 'Process Monitoring',
    meta: { title: 'Monitoring' },
  },
  { path: '/admin/users', component: Users, name: 'Users', meta: { title: 'Users' } },
  { path: '/login-user-monitoring', component: LoginUserMonitoring, name: 'Login User Monitoring', meta: { title: 'Login User Monitoring' } },
  { path: '/admin/systemLog', component: LogList, name: 'LogList', meta: { title: 'System Log' } },
  {
    path: '/management/partner',
    component: PartnerList,
    name: 'Partners',
    meta: { title: 'Partners' },
  },
  {
    path: '/management/ediid',
    component: EdiIdList,
    name: 'EDI ID',
    meta: { title: 'Identification' },
  },
  { path: '/management/codes', component: CodesList, name: 'Codes', meta: { title: 'Codes' } },
  {
    path: '/communication',
    component: CommunicationList,
    name: 'Connectors',
    meta: { title: 'Connectors', compCd: 'COM' },
  },
  {
    path: '/component/folder',
    component: FolderManager,
    name: 'Folder Manager',
    meta: { title: 'Folders', compCd: 'DIR' },
  },
  {
    path: '/component/aiclient',
    component: AIClientList,
    name: 'AI Client',
    meta: { title: 'AI Client', compCd: 'AI' },
  },
  {
    path: '/component/converter',
    component: ConverterList,
    name: 'Converters',
    meta: { title: 'Converters', compCd: 'CVT' },
  },
  {
    path: '/component/filter',
    component: FilterList,
    name: 'Filter List',
    meta: { title: 'Filters', compCd: 'FLT' },
  },
  {
    path: '/process/list',
    component: ProcessListNew,
    name: 'Process Setup New',
    meta: { title: 'Workflow New' },
  },
  {
    path: '/component/dbbroker',
    component: DbBroker,
    name: 'DB Broker',
    meta: { title: 'DB Broker', compCd: 'DBB' },
  },
  {
    path: '/integrationset',
    component: IntegrationSets,
    name: 'Integration Sets',
    meta: { title: 'Integration Sets' },
  },
  { path: '/report', component: Report, name: 'Report', meta: { title: 'Report' } },
  { path: '/404', component: ErrorPage, name: 'ErrorPage' },
  {
    path: '/dashboard',
    component: CaasDashboard,
    name: 'Caas DashBoard',
    meta: { title: 'DashBoard' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/ediasset/repository',
    component: RepositoryManagerList,
    name: 'Repository Manager' /*beforeEnter: requireAuth*/,
  },
  {
    path: '/ediasset/flatFileLayout',
    component: FlatFileLayout,
    name: 'FlatFile Layout',
    meta: { title: 'FlatFile Layout' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/transformation/map',
    component: MapManagerList,
    name: 'Map Manager List',
    meta: { title: 'Mapper', compCd: 'MAP' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/transformation/mapbuilder',
    component: MapBuilder,
    name: 'Map Builder',
    meta: { title: 'Map Builder' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/transformation/codetable',
    component: CodeTableList,
    name: 'Code Table',
    meta: { title: 'Code Tables' },
  },
  {
    path: '/edimanager/analysis',
    component: DataAnalysis,
    name: 'DataAnalysis',
    meta: { title: 'Data Analysis' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/edimanager/srm',
    component: SRMList,
    name: 'SRM List',
    meta: { title: 'Interface List' } /*beforeEnter: requireAuth*/,
  },
  { path: '/edimanager/processsample', component: ProcessSample, name: 'Process Sample List' },
  {
    path: '/edimanager/matching',
    component: CustomerEDIList,
    name: 'Responsity Matching',
    meta: { title: 'Responsity Matching' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/edimanager/EdiAnalyzedView/:id',
    component: EdiAnalyzedView,
    name: 'EdiAnalyzedView',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  {
    path: '/edimanager/EdiAnalyzedView_SRM/:id',
    component: EdiAnalyzedView_SRM,
    name: 'EdiAnalyzedView_SRM',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  {
    path: '/edimanager/LayoutMatchingView',
    component: LayoutMatchingView,
    name: 'LayoutMatchingView',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  {
    path: '/edimanager/AnalysisCompareMerge',
    component: CompareMergeView,
    name: 'CompareMerge',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  {
    path: '/edimanager/UploadFileView/:id',
    component: UploadFileView,
    name: 'UploadFileView',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  {
    path: '/edimanager/JsonEditor',
    component: FileView,
    name: 'JsonEditor' /*beforeEnter: requireAuth*/,
  },
  {
    path: '/edimanager/ExcelUpload',
    component: ExcelUpload,
    name: 'ExcelUpload' /*beforeEnter: requireAuth*/,
  },
  {
    path: '/edimanager/MapEditor',
    component: MapEditor,
    name: 'MapEditor',
    props: true /*beforeEnter: requireAuth*/,
  },
  { path: '/edimanager/TryTest', component: TryTest, name: 'TryTest' /*beforeEnter: requireAuth*/ },
  {
    path: '/edimanager/EdiAnalyzedView_TEST/:id',
    component: EdiAnalyzedView_TEST,
    name: 'EdiAnalyzedView_TEST',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  {
    path: '/ediasset/mappingdefinition',
    component: MappingDefinitionList,
    name: 'MappingDefinitionList',
    meta: { title: 'Mapping Definition' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/ediasset/referencefile',
    component: ReferenceFileList,
    name: 'Reference File List',
    meta: { title: 'Reference Files' } /*beforeEnter: requireAuth*/,
  },

  // For PaProcess
  {
    path: '/paproc/PaProcessList/:server',
    component: PaProcessList,
    name: 'PaProcessList',
    meta: { title: 'Parallel Process Log' } /*beforeEnter: requireAuth*/,
  },
  {
    path: '/paproc/CompFileView/:id',
    component: CompFileView,
    name: 'CompFileView',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  {
    path: '/paproc/TargetFileView/:id',
    component: TargetFileView,
    name: 'TargetFileView',
    /*beforeEnter: requireAuth,*/ meta: {
      popup: true,
    },
  },
  { path: '/', redirect: '/login' },
  {
    path: '/external',
    component: ExternalPage,
    name: 'API Inventory',
    meta: { title: 'API Inventory' },
    props: (route) => ({ query: route.query.uri }),
  },

  { path: '*', redirect: '/404' },
  {
    path: '/users/userDetail/:id',
    component: AddUser,
    name: 'Add User',
    /*beforeEnter: requireAuth*/ meta: {
      //10/16/2020 Fix isssue 9 change new window popup for user add popup
      popup: true,
    },
  },
  {
    path: '/communication/commDetail/:action/:id',
    component: AddCommunication,
    name: 'Add Connector',
    /*beforeEnter: requireAuth*/ meta: {
      //10/16/2020 Fix isssue 9 change new window popup for user add popup
      popup: true,
    },
  },
  {
    path: '/monitoring/monitoringStateView/:action/:id',
    component: MonitoringStateView,
    name: 'MonitoringStateView',
    meta: {
      popup: true,
    },
  },
  {
    path: '/monitoring/monitoringFileView/:action/:id',
    component: MonitoringFileView,
    name: 'MonitoringFileView',
    meta: {
      popup: true,
    },
  },
  {
    path: '/monitoring/monitoringDataInfoFileView/:action/:id',
    component: MonitoringDataInfoFileView,
    name: 'MonitoringDataInfoFileView',
    meta: {
      popup: true,
    },
  },

  {
    path: '/monitoring/token',
    component: EmbeddedMonitoringList,
    name: 'Embedded Monitoring',
    meta: { title: 'Transaction Log' },
  },
  // 2022.05.03 213960 SPKA-443 new workflow
  {
    path: '/process/workflowDetailNew/:action/:id',
    component: AddProcessNew,
    name: 'Add Process New',
    /*beforeEnter: requireAuth*/ meta: {
      //10/16/2020 Fix isssue 9 change new window popup for user add popup
      popup: true,
    },
  },
  {
    path: '/process/workflowDetailNew/:action/:id/:version',
    component: ProcessHistoryNew,
    name: 'Process History New',
    meta: {
      popup: true,
    },
  },
  {
    path: '/process/workflowViewNew/:action/:id',
    component: ProcessViewNew,
    name: 'View Process New',
    meta: {
      popup: true,
    },
  },
  // 2021.05.13 213979 SPKA-460 view process detail
  {
    path: '/admin/systemLog/processDetailWindow/:action/:id',
    component: ProcessDetailWindow,
    name: 'ProcessDetailWindow',
    meta: {
      popup: true,
    },
  },

  // 2022.10.15 213960 workflow group
  {
    path: '/process/workflowgroup',
    component: WorkflowGroup,
    name: 'Workflow Group',
    meta: { title: 'Workflow Group', compCd: 'GRP' },
  },
  {
    path: '/process/workflowGroupDetail/:action/:id',
    component: AddWorkflowGroup,
    name: 'Add Workflow Group',
    meta: {
      popup: true,
    },
  },
  {
    path: '/process/workflowGroupView/:action/:id',
    component: WorkflowGroupView,
    name: 'View Workflow Group',
    meta: {
      popup: true,
    },
  },

  // Smart Agent
  {
    path: '/component/dbadapter',
    component: DBAdapter,
    name: 'DBAdapter',
    meta: { title: 'DBAdapter', compCd: 'DBA' },
  },
  {
    path: '/component/dbadapter/dbadapterbuilder/:action/:id',
    component: DBAdapterBuilder,
    name: 'DBAdapter Builder',
  },
  {
    path: '/component/usercomp/usercomponent',
    component: UserComponent,
    name: 'User Component',
    meta: { title: 'User Component', compCd: 'USR' },
  },
  {
    path: '/component/usercomp/usersimulator',
    component: UserSimulator,
    name: 'User Component Simulator',
    meta: { title: 'User Component Simulator' },
  },
];

const router = new VueRouter({
  base: __dirname,
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes,
  meta: {
    progress: {
      func: [
        { call: 'color', modifier: 'temp', argument: '#ffb000' },
        { call: 'fail', modifier: 'temp', argument: '#6e0000' },
        { call: 'location', modifier: 'temp', argument: 'top' },
        {
          call: 'transition',
          modifier: 'temp',
          argument: { speed: '1.5s', opacity: '0.6s', termination: 400 },
        },
      ],
    },
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'SmartLink Platform';
  next();
});

export default router;
